import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { UtilService } from './services/util.service';
import { APP_MODEL_DATA } from './model-data/app-model-data';
import { environment } from 'src/environments/environment';
import { ICommonModal } from './interface-model/app-interface-model';

@Injectable()
export class AppHTTPInterceptor implements HttpInterceptor {
    appSpinner: string = APP_MODEL_DATA.APP_SPINNER;
    private totalRequests: number = 0;
    
    constructor(private utilService: UtilService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        this.totalRequests++;
        this.utilService.showSpinner(this.appSpinner);

                let authReq = request;
                const isGraphQLRequest = request.url.includes(environment.GraphQL.endpoint);
                if (isGraphQLRequest) {
            const token = this.utilService.getToken('idToken');
            authReq = request.clone({
              setHeaders: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'host': environment.GraphQL.endpoint
              }
            });
                    //  return next.handle(modifiedRequest);
                }

                if (!isGraphQLRequest && this.isBearerTokenRequest(request) && !request.url.includes('pro')) {
            const token = this.utilService.getToken('idToken');
            if (token) {
                authReq = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        RequestedFrom: 'CXPortal'
                    }
                });
            }
        } else if (this.isAccountInfoRequest(request)) {
            const token = this.utilService.getToken('idToken');
            if (token) {
                authReq = request.clone({
                    setHeaders: {
                        Authorization: `${token}`,
                        RequestedFrom: 'CXPortal'
                    }
                });
            }
        } else if (this.isSignOutRequest(request)) {
            const token = 'Basic ' + window.btoa(environment.CLIENT_ID + ":" + environment.CLIENT_SECRET_ID)
            if (token) {
                authReq = request.clone({
                    setHeaders: {
                        Authorization: token,
                        RequestedFrom: 'CXPortal'
                    }
                });
            }
        } else if (this.isExchangeTokenRequest(request)) {
            const token = 'Basic ' + window.btoa(environment.CLIENT_ID + ":" + environment.CLIENT_SECRET_ID)
            if (token) {
                authReq = request.clone({
                    setHeaders: {
                        Authorization: token,
                        RequestedFrom: 'CXPortal'
                    }
                });
            }
        } else  if (this.isBearerTokenRequest(request) && request.url.includes('pro')) {
            const token = this.utilService.getToken('idToken');
            if (token) {
                if(request.url.includes('profile')){
                    authReq = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                } else {
                    authReq = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`,
                            RequestedFrom: 'CXPortal'
                        }
                    });
                }
            
            }
        } else if (!isGraphQLRequest) {
            authReq = request;
        }

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = '';

                if (error?.url?.includes('controllers') && error?.url?.includes('add')) {
                    return throwError(() => error);
                }

                // Handle network errors (status 0)
                if (error && error.status === 0) {
                    this.utilService.hideSpinner(this.appSpinner);
                    this.utilService.clearStorage();
                    if ((this.utilService as any).successErrorModal) {
                        (this.utilService as any).successErrorModal.next();
                    }
                    return throwError(() => error);
                }

                if (error && (this.isBearerTokenRequest(request) || this.isAccountInfoRequest(request))) {
                    if(
                        !(error?.error?.error?.code === 400301) &&
                        !(error?.error?.error?.message === 'NOT_FOUND') &&
                        !(error?.error?.error?.message === 'BAD_REQUEST')
                      ){
                        this.utilService.hideSpinner(this.appSpinner);
                        this.utilService.commonErrorHandler(error);
                    }
                    return throwError(() => error);
                } else if (error && this.isExchangeTokenRequest(request)) {
                    this.utilService.hideSpinner(this.appSpinner);
                    if (error.error.error == 'invalid_grant') {
                        this.utilService.clearStorage();
                        let commonModalData: ICommonModal = this.utilService.expriySessionCheck();
                        this.utilService.commonModal.next(commonModalData);
                    }
                    else {
                        this.utilService.clearStorage();
                        let commonModalData: ICommonModal = this.utilService.exchangeErrorCheck(error.error.error);
                        this.utilService.commonModal.next(commonModalData);
                    }
                    return throwError(() => error);
                }
                return throwError(() => new Error(errorMessage));
            }),
            finalize(() => {
                this.totalRequests--;
                if (this.totalRequests == 0) {
                    this.utilService.hideSpinner(this.appSpinner);
                }
            })
        );

    }

    private isBearerTokenRequest(req: HttpRequest<any>): boolean {
        return req.url.includes('/v1') || req.url.includes('/v2');
    }

    private isAccountInfoRequest(req: HttpRequest<any>): boolean {
        return req.url.includes('/accountInfo');
    }

    private isSignOutRequest(req: HttpRequest<any>): boolean {
        return req.url.includes('/oauth2/revoke');
    }

    private isExchangeTokenRequest(req: HttpRequest<any>): boolean {
        return req.url.includes('&redirect_uri=') || req.url.includes('&refresh_token=');
    }
}
